import dsb_Charts from "@/components/Pages/Dashboard/Graficos.vue"
import dsb_Ramais from "@/components/Pages/Dashboard/Ramais.vue"

export default [
	{
		name: "dsb_Charts",
		path: ":get",
		component: dsb_Charts,
		props: true
	},

	{
		name: "dsb_Ramais",
		path: ":get",
		component: dsb_Ramais,
		props: true
	}
]